// 引入工具函数
import req from '@/utils/request';
// 查询完成诊断记录信息
export const caseDiagnosisRecord = (params) => {
        return req.get('/caseDiagnosis/record', params);
    }
    //获取加工费列表
export const getJGList = (params) => {
        return req.get('/process_way.json', params, '');
    }
    //获取系统时间
export const getSystemTime = (params) => {
        return req.get('/systemTime', params, '');
    }
    //获取消费消息
export const consumeMessage = (params) => {
        return req.get('/task/consumeMessage', params);
    }
    // 获取支付方式
export const getPayWay = (params) => {
        return req.post('/pay/getPayWay', params);
    }
    //获取分类
export const getDictTypeTree = (params) => {
        return req.get('/system/dict/data/dictTypeTree', params);
    }
    // 通过名称获取医保诊断
export const getDiagnoses = (params) => {
        return req.post('/yb/diagnose/list', params);
    }
    // 日志记录
export const saveLog = (params) => {
    return req.post('/common/log/createWeb', params);
}
// 查询会员来源配置
export const getSourceConfig = (params) => {
  return req.get('/share/member/source/config/list', params)
}
// 查询字典值
export const getOption = (params) => {
  return req.get('/chs/getOption', params)
}
export const getYbOption = (params) => {
  return req.get(`/medical/queryDict`,params)
}

//触点
export const touchPoint = (params) => {
  return req.post('/assignment/touchPoint/his', params,'/xl',{timeout: 3 * 1000})
}
//埋点
export const buriedPoint = (params) => {
  return req.post('/assignment/buried_point/pub', params,'/xl')
}

//查询医保库药品数据
export const queryDrug = (params) => {
  return req.post('/chs/1312/query', params)
}

//查询医保库药品数据
export const getDrugRoleOrCate = (params) => {
  return req.get('/hosp/drug/get/role/cate', params)
}

export const getDict = (text) =>{
  return req.get(`/system/dict/data/type/${text}`)
}